import React, {Component} from 'react';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Skeleton from "../../components/Skeleton/Skeleton";
import {connect} from "react-redux";
import {REQUEST_SHIPPING_ADVISORY_DATA} from "../../actions/shippingAdvisoryActions";
import ContentPage from "../../components/ContentPage/ContentPage";


const mapStateToProps = state => {
  return {
    shippingAdvisoryData: state.shippingAdvisoryData
  }
};

const mapDispatchToProps = dispatch => ({
  getShippingAdvisoryData: () => dispatch({type: REQUEST_SHIPPING_ADVISORY_DATA})
});


class ShippingAdvisoryItem extends Component {

  componentDidMount() {
    if (!Object.keys(this.props.shippingAdvisoryData).length) {
      this.props.getShippingAdvisoryData();
    }
  };

  render() {
    return (
      <div className="wrapper">
        <Breadcrumbs/>
        {
          Object.keys(this.props.shippingAdvisoryData).length ? (
            <ContentPage
              content={this.props.shippingAdvisoryData}
              arrayName="advisories"
              redirectPath="/ship/shipping-advisory"
            />
          ) : <Skeleton type="IFRAME"/>
        }
      </div>
    )
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)(ShippingAdvisoryItem));



// WEBPACK FOOTER //
// ./src/pages/ship/ShippingAdvisoryItem.js